import { deleteCentralSystem } from '@infuse/api/e-connector/central-system';
import { useNotify } from '@infuse/cpms/ui';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useDeleteCentralSystem = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: (centralSystemId: number) => deleteCentralSystem({ id: centralSystemId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['central-systems'] });

      notifySuccess({
        title: t('e_connector.common.notify.success'),
        message: t('e_connector.centralSystems.notify.remove.success')
      });
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.centralSystems.notify.remove.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
